export default __webpack_public_path__ + "7c0f9d008256d951362e4e8ec69037e7.png";